import axios from "axios";

// Ensure BASE_URL is correctly retrieved from environment variables
const BASE_URL = process.env.REACT_APP_BASE_URL;

export const fetchSliderServices = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/api/slider`, {
      headers: {
        "Content-Type": "application/json",

      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching services:", error);
    throw error;
  }
};
